/**
 * Help & About Entity
 * Represents a tappable item in the HelpAboutSheet.
 *
 * Flutter source: lib/presentation/screens/settings/app_settings_screen.dart
 * (SettingsItemType — excluding logout/deleteAccount which live in
 * UserActionsSheet, and appVersion which is rendered as a non-clickable footer).
 *
 * Note: `share` and `feedback` were removed from the web variant — those
 * entries moved into `HomeTopBarBody` (see task feat_redesign_home_top_bar).
 */

export enum HelpAboutType {
  CONTACT = 'contact',
  SUPPORT = 'support',
  LEGAL_DOCUMENTS = 'legalDocuments',
  ABOUT = 'about',
}

export interface HelpAboutEntity {
  title: string;
  description: string;
  iconPath: string;
  type: HelpAboutType;
}
